import * as React from "react";
import { useDispatch } from "react-redux";

import actions from "../actions/";
import useInvertedNav from "../hooks/useInvertedNav";
import { PrimaryNavPad } from "../components/organisms/PrimaryNav";

import { ReactComponent as DotsLoader } from "../../assets/images/dots-loader.svg";

const Logout = () => {
    const dispatch = useDispatch();

    // invert primary nav color
    useInvertedNav();

    React.useEffect(() => {
        dispatch(actions.logout(true));
    }, []); // eslint-disable-line

    return (
        <>
            <PrimaryNavPad />
            <div className="contaier-fluid center-xs">
                <br />
                <br />
                <br />
                <br />
                <br />
                <DotsLoader fill={"#008731"} />
                <h2 className="heading-3">Logging out...</h2>
            </div>
        </>
    );
};

export default Logout;
